import { createAction } from '@reduxjs/toolkit';

import type {
  SavedSearchItem,
  SearchSavedSearchesSchemaPatched,
} from '@iconik-io/iconik-api/src/schema_patched/saved_search';
import type { SearchSavedSearchSchemaWithId } from '@iconik-io/iconik-api/src/services/search';

// These actions live outside the slice because both the saved_search and
// saved_search_groups slices reduce them; defining them in either slice
// would create a circular import between the two.
const CREATE_SAVED_SEARCH_SUCCESS = 'saved_search/CREATE_SAVED_SEARCH_SUCCESS';
const DELETE_SAVED_SEARCH_SUCCESS = 'saved_search/DELETE_SAVED_SEARCH_SUCCESS';
const UPDATE_SAVED_SEARCH_SUCCESS = 'saved_search/MODIFY_SAVED_SEARCH_SUCCESS';
const GET_SAVED_SEARCHES_SUCCESS = 'saved_search/GET_SAVED_SEARCHES_SUCCESS';
const GET_SAVED_SEARCHES_NEXT_PAGE_SUCCESS =
  'saved_search/GET_SAVED_SEARCHES_NEXT_PAGE_SUCCESS';

export const createSavedSearchSuccess = createAction<
  SearchSavedSearchSchemaWithId,
  typeof CREATE_SAVED_SEARCH_SUCCESS
>(CREATE_SAVED_SEARCH_SUCCESS);

export const deleteSavedSearchSuccess = createAction<
  string,
  typeof DELETE_SAVED_SEARCH_SUCCESS
>(DELETE_SAVED_SEARCH_SUCCESS);

export const updateSavedSearchSuccess = createAction<
  SavedSearchItem,
  typeof UPDATE_SAVED_SEARCH_SUCCESS
>(UPDATE_SAVED_SEARCH_SUCCESS);

export const getSavedSearchesSuccess = createAction<
  {
    data: SearchSavedSearchesSchemaPatched;
    query: string | undefined;
    groupId: string | null | undefined;
  },
  typeof GET_SAVED_SEARCHES_SUCCESS
>(GET_SAVED_SEARCHES_SUCCESS);

export const getSavedSearchesNextPageSuccess = createAction<
  {
    data: SearchSavedSearchesSchemaPatched;
    groupId: string | null | undefined;
  },
  typeof GET_SAVED_SEARCHES_NEXT_PAGE_SUCCESS
>(GET_SAVED_SEARCHES_NEXT_PAGE_SUCCESS);
